import React from 'react'
import { Link } from 'react-router-dom'
import { getLinkForRepo } from '../../utils/getLinkForRepo'
import Icon from '../misc/Icons'
import DiscoverRepoRatingStars from './DiscoverRepoRatingStars'
import analytics from '../../utils/cdpAnalytics'
import RepoImage from './DiscoverRepoImage'

class DiscoverFeaturedRepoLink extends React.Component {
  constructor() {
    super()
    this.onClickLink = this.onClickLink.bind(this)
  }

  onClickLink() {
    const { repo, rating, market } = this.props
    analytics.track('Click Discover Repo Link', {
      name: repo.name,
      rating,
      author: repo.author.username,
      collection: 'featured',
      market,
    })
  }

  render() {
    const { repo, rating } = this.props

    return (
      <Link
        to={getLinkForRepo(repo)}
        onClick={this.onClickLink}
        className='discover-featuredRepoLink'
      >
        <div className='discover-featuredRepoLink-left'>
          <div className='discover-featuredRepoLink-left-repoImageContainer'>
            <div className='discover-featuredRepoLink-left-repoImage-imgBorder' />
            <RepoImage repo={repo} className='discover-featuredRepoLink-left-repoImage' />
          </div>

        </div>
        <div className='discover-featuredRepoLink-center'>
          <div className='discover-featuredRepoLink-center-title'>
            {repo.name}
          </div>
          <div className='discover-featuredRepoLink-center-creator'>
            {repo.author.username}
          </div>
          {rating && (
          <div className='discover-featuredRepoLink-center-ratingContainer'>
            <DiscoverRepoRatingStars rating={rating} showRatingLabel />

          </div>
          )}
        </div>
        <div className='discover-featuredRepoLink-right'>
          <Icon name='chevron-right' />
        </div>

      </Link>
    )
  }
}

export default DiscoverFeaturedRepoLink
